var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("video", {
      ref: "flvplayerVideoRef",
      attrs: {
        poster: require("@/assets/img/bigScreen/defaultVideoBg.png"),
        controls: true,
        autoplay: "",
        muted: "",
        width: "100%",
      },
      domProps: { muted: true },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }